import { StatusChip } from '@/components/ui/status-chip';
import { FEE_RUN_STATUS_LABEL, feeRunStatusVariant } from '@/features/fee-runs/fee-run-helpers';
import type { FeeRunStatus } from '@/services/api/fee-runs';

export const FeeRunStatusChip = ({ status, className }: { status: FeeRunStatus; className?: string }) => (
  <StatusChip className={className} variant={feeRunStatusVariant(status)}>
    {FEE_RUN_STATUS_LABEL[status]}
  </StatusChip>
);
FeeRunStatusChip.displayName = 'FeeRunStatusChip';
